export default "__VITE_ASSET__D70zNYgC__"